import axios from "axios";
import { Message } from "element-ui";
import router from "@/router";
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 25000 // request timeout
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // config.headers["x-csrftoken"] = cookie.get("csrftoken");
    // config.headers.withCredentials = true;
    return config;
  },
  error => {
    // do something with request error
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (response.status === 204) {
      Message({
        message: "无法查询到相关信息!",
        type: "error",
        duration: 5 * 1000
      });
      return Promise.reject(new Error(res.message || "Error"));
    }
    if (response.status === 403) {
      Message({
        message: "身份认证过期，请重新登录!",
        type: "error",
        duration: 5 * 1000
      });

      sessionStorage.removeItem("hasLogin");
      router.push("login");
    }
    return res;
  },
  error => {
    // console.log(error.response); // for debug
    // Message({
    //   message: error.message.toUpperCase(),
    //   type: "error",
    //   duration: 5 * 1000
    // });
    if (error.response.status === 403) {
      Message({
        message: error.response.data.data.msg,
        type: "error",
        duration: 5 * 1000
      });
      // location.href = '/#/login/'
      window.location = "/#/login/";
    }

    if (error.response.status === 500) {
      Message({
        message: "服务器错误，请稍后再试",
        type: "error",
        duration: 5 * 1000
      });
    }

    return Promise.reject(error);
  }
);

export default service;
